import './DefaultGuaranteeCard.css'

import React from 'react'

function DefaultGuaranteeCard (props) {
  const active = !parseInt(props.checkedWarrantyId)

  return (
    <div className="default-protect-guarantee-item">
      <div className="protect-guarantee-content">
        <input type="radio"
               value={0}
               name="guarantee-default"
               id="guarantee-default"
               onChange={props.onCheckQuarantee}
               checked={active}/>
        <label htmlFor="guarantee-default">
          <div className="protect-guarantee-item-into">
            <span className="protect-guarantee-item-title">{props.name}</span>
          </div>
        </label>
      </div>
    </div>
  )
}

export default DefaultGuaranteeCard